import homeHero from './home_hero.png';
import homeCards from './home_cards.png';
import feature from './feature.png';
import expo from './expo.png';
import expo02 from './expo02.png';
import javascript from './javascript.png';
import react from './react.png';
import scene from './scene.png';
import mockup from './mockup.png';

const assets = {
  homeHero,
  homeCards,
  feature,
  expo,
  expo02,
  javascript,
  react,
  scene,
  mockup,
};

export default assets;
